import { isEditOrPreviewMode } from '@/lib/editModeHelpers';
import { useGetGlobalElementQuery } from '@/redux/api/contentDeliveryAPI';
import { RootState } from '@/redux/store';
import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

export interface QuickNavProps {
  pageId?: number;
}

const QuickNav = ({ pageId }: QuickNavProps) => {
  const authState = useSelector((state: RootState) => state.auth);
  const userId = useSelector((state: RootState) => state?.auth?.name || 'ANON');
  const isEditMode = isEditOrPreviewMode();

  userId;
  const { data: quickNavData } = useGetGlobalElementQuery(
    { name: 'quicknav', userId },
    { skip: !authState.ready }
  );
  const { success } = quickNavData || {};

  const epiOptions = useMemo(
    () => ({
      menuItems: {
        Dashboard: {
          caption: 'Dashboard',
          url: `${window.env?.CONTENT_DELIVERY_API}/EPiServer/CMS/dashboard`,
          javascript: null,
          enabledScript: 'true',
          imageUrl: null
        },
        EditMode: {
          caption: 'CMS Edit',
          url: `${window.env?.CONTENT_DELIVERY_API}/EPiServer/CMS/?language=en#context=epi.cms.contentdata:///${pageId}`,
          javascript: null,
          enabledScript: 'true',
          imageUrl: null
        },
        Commerce: {
          caption: 'Commerce',
          url: `${window.env?.CONTENT_DELIVERY_API}/EPiServer/Commerce/Catalog?moduleArea=EPiServer.Commerce.Shell`,
          javascript: null,
          enabledScript: 'true',
          imageUrl: null
        }
      },
      menuTitle: 'Edit Page',
      defaultUrl: `${window.env?.CONTENT_DELIVERY_API}/EPiServer/CMS/?language=en#context=epi.cms.contentdata:///${pageId}`
    }),
    [pageId]
  );

  useEffect(() => {
    const { epi } = window;
    const existingInstance = epi?.QuickNavigator?.instance;

    if (!epi?.QuickNavigator || !pageId || !success || isEditMode) {
      existingInstance?.destroy(true);
      return;
    }

    existingInstance?.destroy(true);

    const epiInstance = new epi.QuickNavigator(epiOptions);
    epiInstance.initialize();

    return () => epiInstance.destroy();
  }, [pageId, epiOptions, success, isEditMode]);

  return null;
};

export default QuickNav;
